module.exports = __webpack_public_path__ + "static/img/smudge_overlay.57201d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/smudge_overlay.png
// module id = 947
// module chunks = 0